import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import { useMount } from "@sportal/cdk";

import { AuthRouter } from "./AuthRouter";
import { ScrollToTop } from "./ScrollToTop";
import { ModalHost } from "../components/modal";
import { sizes } from "../common/Responsive";
import { HelpPage } from "../pages";

function stripHash(url) {
  const hashIndex = url.indexOf("#");

  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + "#" + path);
}

function getHashPath() {
  const href = window.location.href;
  const hashIndex = href.indexOf("#");

  return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function handleHashChange() {
  const path = getHashPath();
  const encodedPath = addLeadingSlash(path);

  if (path !== encodedPath) {
    replaceHashPath(encodedPath);
  }
}

export const Router = () => {
  useMount(() => {
    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);

    return () => window.removeEventListener("hashchange", handleHashChange);
  });

  return (
    <HashRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/*" element={<AuthRouter />} />
        <Route path="/help">
          <Route index element={<HelpPage />} />
          <Route path=":section" element={<HelpPage />} />
        </Route>
      </Routes>
      <ModalHost mobileBreakpoint={sizes.mobileMax} />
    </HashRouter>
  );
};
